import React from 'react';
import {AppTheme, getHeartLogoLink, getFullLogoLink, noProfilePicture} from '../../../appTheme';
import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';
import styles from './SidebarPanel.module.scss';
import {MenuItemsForRole} from './MenuItemsForRole';
import {userStore} from '../../../redux/entities/user';
import {roleStore} from '../../../redux/entities/role';
import {CommonState} from '../../../redux';
import {Link} from 'react-router-dom';
import {RoutePaths} from '../../../router/RoutePaths';
import {Avatar, Burger, Group, Navbar, ScrollArea, Stack, Text} from '@mantine/core';
import StyledActionButton from '../../util/widgets/StyledActionButton/StyledActionButton';
import {useMediaQuery} from '@mantine/hooks';

 type OwnProps = { onOpenExport?: () => void; onOpenProfile?: () => void; onOpenAuditLogs?: () => void };
 type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const SidebarPanel = (props: Props) => {
  const {currentUser, onOpenExport, onOpenProfile, onOpenAuditLogs} = props;
  const [collapsed, setCollapsed] = React.useState(true);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const bg = AppTheme.colors.themeGreen;
  const fg = '#ffffff';

  const hiddenOnMobile = isMobile && collapsed;

  return (
    <>
      {isMobile && (
        <div
          className={styles['sidebar-burger-icon']}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: 48,
            margin: 0,
            backgroundColor: AppTheme.colors.themeGreen,
            display: 'flex',
            alignItems: 'center',
            zIndex: 10,
          }}
        >
          <StyledActionButton
            size="xl"
            onClick={() => setCollapsed((c) => !c)}
            color={fg}
            aria-label="Open sidebar"
            icon={'bars'}
          />
          <img src={getHeartLogoLink()} alt="HOTI Portal" className={styles['logo']} style={{marginLeft: 'auto', marginTop: '1.5rem', marginRight: '1rem', maxHeight: '60%'}}/>
        </div>
      )}
      {!hiddenOnMobile && (
        <Navbar
          width={{ base: collapsed ? 72 : 174 }}
          p="xs"
          className={styles['animatedNavbar']}
          style={{ backgroundColor: bg, color: fg, borderRight: `1px solid ${bg}`, minHeight: '100vh' }}
        >
          {!isMobile && <Navbar.Section>
            <Stack spacing={6} align="center">
              <Burger opened={!collapsed} onClick={() => setCollapsed((c) => !c)} color={fg} size="sm" aria-label="Toggle navigation" />
            </Stack>
          </Navbar.Section>}

          <Navbar.Section grow style={{ marginTop: '0.5rem' }}>
            {MenuItemsForRole(currentUser, collapsed, onOpenExport, onOpenAuditLogs)}
          </Navbar.Section>

          <Navbar.Section>
            {collapsed ? (
              <Stack align="center" spacing={8} style={{ paddingBottom: '0.5rem' }}>
                <img src={getHeartLogoLink()} alt="HOTI Portal" className={styles['logo']}/>
                <StyledActionButton
                  tooltip="Profile"
                  onClick={onOpenProfile}
                  size="lg"
                  color={fg}
                  avatarSrc={currentUser?.profilePicturePath || noProfilePicture()}
                />
                <StyledActionButton
                  tooltip="Logout"
                  to={RoutePaths.authPaths.logout}
                  size="lg"
                  color={fg}
                  icon={'sign-out-alt'}
                />
              </Stack>
            ) : (
              <Group p="sm" position="apart" align="center">
                <img src={getFullLogoLink()} alt="HOTI Portal" className={styles['logo']} />
                <Group spacing="md" align="center" noWrap={true}>
                  <div>
                    <Text weight={600} color={fg} size="sm" style={{ lineHeight: 1 }}>
                      {currentUser?.name}
                    </Text>
                    <Text color={fg} size="xs" style={{ opacity: 0.9 }}>
                      {currentUser?.role.roleName}
                    </Text>
                  </div>
                  <StyledActionButton
                    tooltip="Profile"
                    onClick={onOpenProfile}
                    size="lg"
                    color={fg}
                    avatarSrc={currentUser?.profilePicturePath || noProfilePicture()}
                  />
                  <StyledActionButton
                    tooltip="Logout"
                    to={RoutePaths.authPaths.logout}
                    size="lg"
                    color={fg}
                    icon={'sign-out-alt'}
                  />
                </Group>
              </Group>
            )}
          </Navbar.Section>
        </Navbar>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({actions: bindActionCreators({}, dispatch)});
const mapStateToProps = (state: CommonState) => ({
  currentUser: userStore.selectors.getCurrentUser(state),
  roleName: roleStore.selectors.getById(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarPanel);
